<template>
  <Container class="container-sm-none">
      <Card class="card-shadow mt-15 mt-md-0">
        <div class="width-lg">
          <div class="pl-10 pl-md-0 pr-10 pr-md-0">
            <IconFamily />
            <p class="heading-2 heading-md-1 weight-medium mt-20">
              Your application progress has been saved!
            </p>
            <p class="body-3 body-md-1 weight-regular mt-10">
              We have e-mailed you {{ model.insurer.email }} 
    a link to re-open the application form at the last completed step and finish it at any time.
  
            </p>

            <ButtonGroup class="pt-20">
              <Button
                v-if="showReturnHomeButton"
                class="btn-outline-tertiary w-full"
                @click="redirectBack"
              >
                Go to Main Page
              </Button>
              <Button
                class="btn-primary w-full"
                :icon-right="require('@/assets/svg/icon-right-white.svg')"
                @click="redirectToNext"
              >
                Complete Your Application Now
              </Button>
            </ButtonGroup>
          </div>
        </div>
      </Card>
  </Container>
</template>

<script>
import Card from '@/components/Card/Card.vue';
import Container from '@/components/Container/Container.vue';
import Button from '@/components/Button/Button.vue';
import IconFamily from '@/components/Icons/IconFamily.vue';
import ButtonGroup from '@/components/ButtonGroup/ButtonGroup.vue';
import GA from '@/mixins/GA';
import { setHashChannelParams } from '@/utils/urlParams';
import url from '@/mixins/url';

export default {
  name: 'ThankYouFail',
  components: {
    ButtonGroup,
    IconFamily,
    Button,
    Card,
    Container,
  },
  mixins: [GA, url],
  props: {
    model: { required: true, type: Object },
  },
  created() {
    this.$router.maxStep = 23;
    this.model.step = 23;
    if (this.model.lastStep < 23) this.model.lastStep = 23;
  },
  mounted() {
    this.funnelSaved();
  },
  methods: {
    redirectToNext() {
      const search = `?lead=${this.model.leadUuid}`;
      const { hash, channel } = this.$route.query;
      const otherParams = setHashChannelParams(hash, channel, true);
      window.location.replace(`${window.location.origin + window.location.pathname}#landing-page${search}${otherParams}`);
      window.location.reload();
    },
    redirectBack() {
      window.location.reload();
    },
  },
};
</script>
